import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import ReactTooltip from "react-tooltip";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import Contact from "../base/Contact";
import UITableUtils from "../util/UITableUtils";
import CollapsibleNote from "../base/CollapsibleNote";

import UIUtils from "../util/UIUtils";
import ApiUtils from '../util/ApiUtils';
import "../styles/charts.css";
import "./Relayers.css";
import Utilities from "../util/Utilities";
import FavUtils from "../util/FavUtils";
import RespUtils from "../util/RespUtils";

import MainUtils from "../main/MainUtils";
import constants from '../constants';
import DataUtils from '../util/DataUtils';
import ProjectUIUtils from '../projects/ProjectUIUtils';
import RelayerInline from './RelayerInline';
import RelayerUtils from './RelayerUtils';
import ChartTitle from '../components/ChartTitle';
import AppList from '../base/AppList';

class Relayers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      relayers: [],
      selectedChains: [],
      notification: {"message": null},
      width: window.innerWidth,
      size: 10,
      lastUpdated: "",
      isLoading: true,
      isLoadingChains: true,
      isHelpOpen: false,
      chainConfig: [],
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    this.reload = this.reload.bind(this);
    this.getInitColumns = this.getInitColumns.bind(this);
    this.repaintData = this.repaintData.bind(this);
    this.setSelectedChains = this.setSelectedChains.bind(this);
    this.updateData = this.updateData.bind(this);
    this.renderAdditionalLink = this.renderAdditionalLink.bind(this);
  }

  updateDimensions() {
    this.setState({width: window.innerWidth});
  }

  componentWillMount() {
    this.updateDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);

    await RelayerUtils.loadChainConfig(this);
    this.updateData(this.state.selectedChains);
  }

  async setSelectedChains(e) {
    this.setState({"selectedChains": e});
    await this.updateData(e);
  }

  async updateData(appList) {
    let url = "relayers";

    let apps = "";
    for (let i = 0; i < appList.length; i++) {
      if (i !== 0) {
        apps += ",";
      }
      apps += appList[i]["value"];
    }

    if (apps != "") {
      url += "?chains=" + apps;
    }

    const allData = await ApiUtils.get(url);
    if (!allData) {
      this.setState({error: true, isLoading: false});
      return;
    }

    let relayers = allData["relayers"];
    if (relayers) {
      relayers = DataUtils.addIndex(relayers, "validatorId");

      this.setState({relayers: relayers});
    }

    this.setState({isLoading: false});
  }

  repaintData() {
    let validators = this.state.validators;
    let newValidators = UIUtils.addIndexAndFav(validators, "poolId");
    let finalData = FavUtils.filterData(this, newValidators);
    this.setState({validators: finalData});
  }

  render() {
    let loadMsg = UIUtils.getLoading(this);

    if (loadMsg) return loadMsg;

    if (this.state.isLoadingChains) return "";

    const headerSortingClasses = (column, sortOrder, isLastSorting, colIndex) => (
      sortOrder === 'asc' ? 'sorting-asc' : 'sorting-desc'
    );
    
    var columns = [
      {text: "#", desc: "Index", hidden: RespUtils.isMobileView(), dataField: "index", sort: true, align: "left", headerStyle: Utilities.width(4), headerSortingClasses},
      {text: "", filter: textFilter({placeholder: "Name"}), desc: "Relayer", hidden: this.isHidden("name"), dataField: "name", formatter: MainUtils.nameFormatterTableWithLogo, sort: true, headerStyle: Utilities.respWidth(40, 35, 20), headerSortingClasses},
      {text: "Contacts",  desc: "Relayer Contact Info", hidden: RespUtils.isTabletView(), dataField: "twitter", formatter: ProjectUIUtils.formatMedia, sort: true, headerStyle: Utilities.respWidth(20, 20, 10), headerSortingClasses},
      {text: "30D Nonce",  desc: "Delta nonce of all known addresses in last 30 days", dataField: "monthlyDeltaNonce", sort: true, headerStyle: Utilities.respWidth(15, 15, 10), headerSortingClasses},
      {text: "90D Nonce",  desc: "Delta nonce of all known addresses in last 90 days", dataField: "quarterlyDeltaNonce", sort: true, headerStyle: Utilities.respWidth(15, 15, 10), headerSortingClasses},
      {text: "Relayer Count",  desc: "Relayer Count", hidden: RespUtils.isTabletView(), dataField: "relayCount", sort: true, headerStyle: Utilities.respWidth(15, 12, 10), headerSortingClasses},
      {text: "Chains Relayed",  desc: "Chains Relayed", hidden: this.isHidden("chainsRelayed"), dataField: "chainsRelayed", formatter: RelayerUtils.formatRelChains, formatExtraData: this.state.chainConfig, sort: true, headerStyle: Utilities.respWidth(40, 25, 25), headerSortingClasses},
      {text: "Chains Validated (Bonded)",  desc: "Chains Validated", hidden: RespUtils.isMobileView(), dataField: "chainsValidated", formatter: RelayerUtils.formatValChains, formatExtraData: this.state.chainConfig, sort: true, headerStyle: Utilities.respWidth(20, 20, 20), headerSortingClasses},
      // {text: "Chains Relayed",  desc: "Chains Relayed", hidden: this.isHidden("chainsRelayed"), dataField: "chainsRelayed", formatter: RelayerUtils.formatChainsText, sort: true, headerStyle: Utilities.respWidth(25, 25, 25), headerSortingClasses},
      // {text: "Chains Validated",  desc: "Chains Validated", hidden: this.isHidden("chainsValidated"), dataField: "chainsValidated", formatter: RelayerUtils.formatChainsText, sort: true, sortFunc: Utilities.sortNumeric, headerStyle: Utilities.respWidth(35, 35, 35), headerSortingClasses},
      {text: "Support by",  desc: "How can you support the Relayer", hidden: RespUtils.isTabletView(), dataField: "supportRelayerBy", sort: true, headerStyle: Utilities.respWidth(20, 20, 20), headerSortingClasses},
    ];

    const options = {
      onlyOneExpanding: true,
    };

    const expandRow = {
      renderer: row => (
        <RelayerInline relayer={row} />
      ), showExpandColumn: false
    };

    // let wrapperClasses = UITableUtils.isDefaultView() ? "table":"table-responsive";
    // const rowStyle = (row, rowIndex) => {
    //   return { backgroundColor: UITableUtils.getWeightColor(row.cumulativeWeight) };
    // };rowStyle={rowStyle}

    return (
      <div>
        {/* <PageHeader title={"Interchain Relayers"} thisObj={this} disableStakeFormatter={true} /> */}
        <p/>
        <ReactTooltip id="main" place="top" type="dark" effect="float" multiline={true} />
        <ToolkitProvider keyField="validatorId" data={this.state.relayers} columns={columns} columnToggle>
          {
            props => (
              <div>
                <ChartTitle title="Interchain Relayers" showAdditionalLink={true} renderAdditionalLink={this.renderAdditionalLink}/>
                {/* <ValColumnSelector settingKey={constants.app.VALIDATORS_KEY} getInitColumns={this.getInitColumns} showHelp={this.showHelp}
                  statusSummary={this.state.statusSummary} { ...props.columnToggleProps } refreshParent={this.repaintData} /> */}
                <p><small>**Tx count shown is simply a delta change in address nonce and may be inaccurate. Data shown based on addresses that are shared via {RelayerUtils.getGithub()}<br/> Note: initial data for "90 days" metric will keep building until 15th May 2024.</small></p>
                <BootstrapTable options={options} { ...props.baseProps } 
                    filter={ filterFactory() }
                    expandRow={ expandRow } expandableRow={ () => { return true; } } 
                    condensed noDataIndication="No Data" />
              </div>
            )
          }
        </ToolkitProvider>
        <p/>
        <p>Update your relayer's data at {RelayerUtils.getGithub()}</p>
        <CollapsibleNote getScreenGuide={RelayerUtils.getRelayersNote} />
        <Contact />
      </div>
    );
  }

  reload() {
    window.location = "/";
  }

  getInitColumns() {
    let columnsConfig = {};
    if (RespUtils.isTabletView()) {
      columnsConfig = {
        index:true, name: false, chainsRelayed: false, chainsValidated: false, 
      };

    } else {
      columnsConfig = {
        index:false, name: false, chainsRelayed: false, chainsValidated: false, 
      };
    }

    // console.log("columns config is: ", columnsConfig);
    return columnsConfig;
  }

  isHidden(dataField) {
    return UITableUtils.isHidden(constants.app.VALIDATORS_KEY, dataField, this.getInitColumns);
  }

  renderAdditionalLink() {
    // console.log(this.state.selectedChains);
    return <AppList selectedApps={this.state.selectedChains} setApplist={this.setSelectedChains}/>;
  }

}

export default Relayers;
